var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5H16V10H5.5C4.4 10 3.45833 9.60833 2.675 8.825C1.89167 8.04167 1.5 7.1 1.5 6C1.5 4.9 1.89167 3.95833 2.675 3.175C3.45833 2.39167 4.4 2 5.5 2H16C16.7 2 17.2917 2.24167 17.775 2.725C18.2583 3.20833 18.5 3.8 18.5 4.5C18.5 5.2 18.2583 5.79167 17.775 6.275C17.2917 6.75833 16.7 7 16 7H6.5C6.21667 7 5.97933 6.904 5.788 6.712C5.596 6.52067 5.5 6.28333 5.5 6C5.5 5.71667 5.596 5.479 5.788 5.287C5.97933 5.09567 6.21667 5 6.5 5H16V3.5H6.5C5.8 3.5 5.20833 3.74167 4.725 4.225C4.24167 4.70833 4 5.3 4 6C4 6.7 4.24167 7.29167 4.725 7.775C5.20833 8.25833 5.8 8.5 6.5 8.5H16C17.1 8.5 18.0417 8.10833 18.825 7.325C19.6083 6.54167 20 5.6 20 4.5C20 3.4 19.6083 2.45833 18.825 1.675C18.0417 0.891667 17.1 0.5 16 0.5H5.5C3.96667 0.5 2.66667 1.03333 1.6 2.1C0.533333 3.16667 0 4.46667 0 6C0 7.53333 0.533333 8.83333 1.6 9.9C2.66667 10.9667 3.96667 11.5 5.5 11.5Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.0685a5c1c394d42b8b8c39b92a7a6097.svg";
export { ForwardRef as ReactComponent };